import gql from 'graphql-tag'

export default gql`
mutation createProduct($record: CreateOneProductInput!) {
  createProduct(record: $record) {
    record {
      _id
      group
      name
      size
      color
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/createProduct.js